module.exports = __webpack_public_path__ + "static/media/sc_logo_icon.05d890cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sc_logo_icon.svg
// module id = 964
// module chunks = 0